import React from 'react'
import FlexContainer from 'core-system/FlexContainer'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import styled from 'styled-components'
import NumberInput from 'core-system/Input/NumberInput/NumberInput'
import NumberFormatter from 'core-system/Input/NumberInput/NumberFormatter'
import FormattingUtils from 'shared/FormattingUtils'

const IconContainer = styled.div`
  min-width: 2.5rem;
  height: 2.5rem;
  background-color: ${(props) => props.theme.palette.secondary.purple600};
  border-radius: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`

interface TransitParkingEmployerContributionProps {
  type: 'Transit' | 'Parking'
  title?: 'Contribution' | 'Allocation'
  icon: React.ReactNode
  canEdit: boolean
  contributionAmount: number
  onContributionChange: (amount: number) => void
  maxContribution: number
  active: boolean
}

const TransitParkingEmployerContribution = ({
  type,
  title = 'Contribution',
  icon,
  canEdit,
  contributionAmount,
  onContributionChange,
  maxContribution,
  active,
}: TransitParkingEmployerContributionProps) => {
  return (
    <FlexContainer flexDirection='column' marginBottom='1rem'>
      <Text variant='body1' marginBottom='1rem'>
        {type} {title}
      </Text>
      <FlexContainer>
        <IconContainer>{icon}</IconContainer>
        <FlexContainer
          flexDirection='column'
          justifyContent='center'
          marginLeft='1rem'
          width={'100%'}
        >
          {active && canEdit ? (
            <FlexContainer flexDirection='column'>
              <NumberInput
                padding='1rem'
                onValueChange={onContributionChange}
                value={contributionAmount / 100}
                iconSize={20}
                incrementVal={5}
                maxHeight='2.5rem'
              >
                <NumberFormatter decimalScale={0} fontVariant='action2' />
              </NumberInput>
            </FlexContainer>
          ) : (
            <Text
              variant='h4'
              textColor={active ? palette.text.primary : palette.text.disabled}
            >
              {active
                ? FormattingUtils.formatDollar(contributionAmount, 0)
                : `${type.toUpperCase()} NOT ACTIVE`}
            </Text>
          )}
        </FlexContainer>
      </FlexContainer>
      {canEdit &&
      active &&
      (maxContribution < contributionAmount || contributionAmount < 0) ? (
        <FlexContainer marginLeft='4rem' marginTop='0.25rem'>
          <Text variant='body2' textColor={palette.error.red600}>
            Please enter a value equal to or less than{' '}
            {FormattingUtils.formatDollar(maxContribution, 0)}
          </Text>
        </FlexContainer>
      ) : null}
    </FlexContainer>
  )
}

export default React.memo(TransitParkingEmployerContribution)
